import {makeObservable, observable, runInAction} from 'mobx';

export default class GlobalStore {
  public stores: Map<string, BaseStore> = new Map<string, BaseStore>();

  public addStoreToList<T extends BaseStore>(identifier: string, Store: new (...args: any[]) => T, ...params: any) {
    this.stores.set(identifier, new Store(...params));
  }

  public getStore<T>(identifier: string) {
    return this.stores.get(identifier) as T;
  }

  public createStore<T>(Store: new (...args: any[]) => T, ...params: any) {
    return new Store(params);
  }
}

export class BaseStore {}
